import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    parcoursFormaliteBasePath,
    parcoursFormaliteClientsStepPath,
    parcoursFormaliteDocsStepPath,
    parcoursFormaliteFormaliteStepPath,
    parcoursFormaliteFormStepPath,
    parcoursFormaliteNextFormStepPath,
    parcoursFormaliteRecapStepPath,
} from './constants';
import ParcoursFormaliteRoot from './ParcoursFormaliteRoot';
import StepSelectionFormalites from './steps/StepSelectionFormalites';
import StepSelectionClient from './steps/StepSelectionClient';
import StepFormulaires from './steps/StepFormulaires';
import StepRecap from './steps/StepRecap';
import StepDocFirst from './steps/StepDocFirst';
import StepNextForm from './steps/StepNextForm';

export const ParcoursFormaliteRouter: RouteObject = {
    path: parcoursFormaliteBasePath,
    element: <ParcoursFormaliteRoot />,
    children: [
        {
            path: parcoursFormaliteFormaliteStepPath,
            element: <StepSelectionFormalites />,
        },
        {
            path: parcoursFormaliteClientsStepPath,
            element: <StepSelectionClient />,
        },
        {
            path: `${parcoursFormaliteFormStepPath}/:indexPresta/:page`,
            element: <StepFormulaires />,
        },
        {
            path: parcoursFormaliteDocsStepPath,
            element: <StepDocFirst />,
        },
        {
            path: parcoursFormaliteRecapStepPath,
            element: <StepRecap />,
        },
        {
            path: `${parcoursFormaliteNextFormStepPath}/:indexPresta/:page`,
            element: <StepNextForm />,
        },
    ],
};

export const ParcoursFormaliteRouterBack: RouteObject = {
    ...ParcoursFormaliteRouter,
    element: <ParcoursFormaliteRoot back />,
};
